export default __webpack_public_path__ + "static/media/MBK.eb973f41.pdf";